import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { 
    persistReducer, 
    persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import userReducer from './auth/userSlice';
import companyReducer from './core/companySlice';
import themeReducer from './themeSlice';
import featureReducer from './featureSlice';
import { setupInterceptors } from '../api';

const persistConfig = {
    key: 'root',
    storage, 
    whitelist: ['user', 'theme'],
};

const rootReducer = combineReducers({
    user: userReducer,
    company: companyReducer,
    theme: themeReducer,
    features: featureReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

setupInterceptors(store);

export const persistor = persistStore(store);

export default store;